<template>
	<div class="items">
		<div class="list">
			<item v-for="item in items.data" :key="item.id" v-bind="item"/>
		</div>

		<a class="more" v-if="!end" @click="more">Hent flere nyheder</a>
	</div>
</template>

<script>
import item from "./item.vue";

export default {
	components: {item},
	computed: {
		end: (t) => t.items.meta.current_page === t.items.meta.last_page,
		items() {
			return this.$store.getters["news/items"];
		}
	},
	methods: {
		more() {
			this.$store.dispatch("news/getItems", {more: true});
		},
	},
	created() {
		if(!this.items.data.length) {
			this.$store.dispatch("news/getItems");
		}
	}
};
</script>

<style lang="scss" scoped>
.items {
	margin: 0 auto;
	margin-top: 42px;
	max-width: 819px;

	@include res(mobile) {
		margin-top: 22px;
	}

	.list {

	}

	.more {
		margin-top: 42px;
		display: block;
		text-align: center;
		font-size: 16px;
		font-weight: 500;
		color: #4A4A4A;
	}
}
</style>
